'use strict';

export default class VideoFac {
  static get UID() {
    return 'videoFac';
  }

  constructor($http, BASE_URLS) {
    'ngInject';
    Object.assign(this, { $http, BASE_URLS } );
  }

  getTrailer(updateId) {
    var url = `${this.BASE_URLS.API}/api/update/${updateId}/trailer/`;

    return this.$http.get(url);
  }

  static factory($http, BASE_URLS) {
    return new VideoFac($http, BASE_URLS);
  }
}

VideoFac.factory.$inject = VideoFac.$inject;



// WEBPACK FOOTER //
// ./~/site_core/src/factories/videoFac.js